// extracted by mini-css-extract-plugin
export default {"storyContent":"Skeleton_storyContent__IJnEg"};